import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { useApplicationStore } from 'modules/application/store';

export const useCanvasAspect = () => {
  const aspect = useThree((state) => state.viewport.aspect);

  useEffect(() => {
    useApplicationStore.getState().setCanvasAspect(aspect);
  }, [aspect]);
};
